import { create } from "zustand";
import { PersonalizationStore } from "../types";

export const usePersonalizationStore = create<PersonalizationStore>((set) => ({
    answerLength: (() => {
        const saved = localStorage.getItem('answerLength');
        return (saved as 'brief' | 'standard' | 'detailed') || 'standard';
    })(),
    enableIcons: (() => {
        const saved = localStorage.getItem('enableIcons');
        return saved ? saved === 'true' : false;
    })(),
    responseTone: (() => {
        const saved = localStorage.getItem('responseTone');
        return (saved as 'professional' | 'standard' | 'friendly') || 'standard';
    })(),
    setAnswerLength: (length: 'brief' | 'standard' | 'detailed') => {
        localStorage.setItem('answerLength', length);
        set({ answerLength: length });
    },
    setEnableIcons: (enabled: boolean) => {
        localStorage.setItem('enableIcons', enabled.toString());
        set({ enableIcons: enabled });
    },
    setResponseTone: (tone: 'professional' | 'standard' | 'friendly') => {
        localStorage.setItem('responseTone', tone);
        set({ responseTone: tone });
    },
}));
